<div class="login-container gradient-bg  relative z-20 h-full">
    <!-- Enhanced Header -->
    <header *ngIf="!minimal"  class="sticky top-0 z-30 bg-black bg-opacity-20 backdrop-blur-md border-b border-white border-opacity-20">
        <div class="flex justify-between items-center px-4 sm:px-6 py-4">
            <button class="back-btn flex items-center justify-center w-10 h-10 rounded-full border-2 border-white border-opacity-50 text-white cursor-pointer transition-all duration-300 hover:bg-white hover:bg-opacity-20 hover:transform hover:-translate-x-0.5" 
                    (click)="navigateBackUrl()">
                <i class="pi pi-arrow-left text-sm"></i>
            </button>
            <div class="text-white text-sm font-medium hidden sm:block">
                Secure Login
            </div>
        </div>
    </header>

    <!-- Main Content -->
    <main class="flex flex-col lg:flex-row ">
        <!-- Left Panel - Advertisement/Branding (Desktop Only) -->
        <div class="hidden lg:flex lg:w-1/2 xl:w-3/5 items-center justify-center p-8" 
             >
            <div class="glass-effect rounded-3xl p-8 max-w-md w-full fade-in">
                <div class="text-center">
                    <div class="w-32 h-32 mx-auto mb-6 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                        <i class="pi pi-shop text-4xl text-white"></i>
                    </div>
                    <div class="mb-6">
                        <app-advertisement [size]="'large'"></app-advertisement>
                    </div>
                    <div *ngIf="!minimal && !isMobileScreen" class="space-y-3 text-white text-opacity-80 text-sm">
                        <div class="flex items-center">
                            <i class="pi pi-check-circle mr-3 text-green-300"></i>
                            <span>Exclusive member deals</span>
                        </div>
                        <div class="flex items-center">
                            <i class="pi pi-check-circle mr-3 text-green-300"></i>
                            <span>Fast & secure checkout</span>
                        </div>
                        <div class="flex items-center">
                            <i class="pi pi-check-circle mr-3 text-green-300"></i>
                            <span>24/7 customer support</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Right Panel - Login Form -->
        <div class="flex-1 lg:w-1/2 xl:w-2/5 flex items-center justify-center p-4 sm:p-6 lg:p-8">
            <div class="w-full max-w-md">
                <!-- Logo Section -->
                <div class="text-center mb-8 fade-in" *ngIf="!minimal">
                    <div class="inline-block p-4 glass-effect rounded-2xl mb-6 hover-scale cursor-pointer transition-transform duration-200 hover:scale-105" 
                         routerLink="dashboard">
                        <img class="w-20 h-16 object-contain" 
                             src="https://images.mashhoorplus.in/file/17445388814070199A2F5-E4E9-41A2-A62B-D2A356418AA9.png"
                             alt="MashhoorPlus Logo">
                    </div>
                    <h1 class="text-2xl sm:text-3xl font-bold welcome-text mb-2">Welcome</h1>
                    <p class="text-white text-opacity-80 text-sm sm:text-base">Enter your phone to unlock exclusive discounts</p>
                </div>

                <!-- Mobile Welcome Message -->
                <div class="lg:hidden mb-6 fade-in" >
                    <div class="glass-effect rounded-2xl p-4 text-center">
                        <p class="text-white text-sm mb-3">🎉 Welcome! Register to avail the best deals!</p>
                        <div class="mb-4">
                            <app-advertisement [size]="'small'"></app-advertisement>
                        </div>
                        <div *ngIf="!minimal && isMobileScreen" class="grid grid-cols-3 gap-2 text-xs text-white text-opacity-80">
                            <div class="flex flex-col items-center">
                                <i class="pi pi-percentage mb-1"></i>
                                <span>Best Deals</span>
                            </div>
                            <div class="flex flex-col items-center">
                                <i class="pi pi-send mb-1"></i>
                                <span>Fast Delivery</span>
                            </div>
                            <div class="flex flex-col items-center">
                                <i class="pi pi-shield mb-1"></i>
                                <span>Secure</span>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Login Form Container -->
                <div class="glass-effect rounded-3xl p-6 sm:p-8 fade-in">
                    <!-- OTP Login Component -->
                    <div *ngIf="!phoneNumber" class="space-y-6">
                        <app-otp-login 
                            [title]="title" 
                            [minimal]="minimal" 
                            (OtpSentSuccess)="handleOtpSenSuccess($event)"
                            class="block">
                        </app-otp-login>
                    </div>

                    <!-- OTP Verification Component -->
                    <div *ngIf="phoneNumber" class="space-y-6">
                        <div class="text-center mb-6">
                            <i class="pi pi-mobile text-3xl text-white mb-3"></i>
                            <h3 class="text-white text-lg font-semibold mb-2">Verify OTP</h3>
                            <p class="text-white text-opacity-80 text-sm">Enter the code sent to {{phoneNumber}}</p>
                        </div>
                        
                        <app-otp-verify 
                            (loggedIn)="handleLogin()" 
                            [phoneNumber]="phoneNumber"
                            class="block">
                        </app-otp-verify>
                    </div>

                    <!-- Additional Options -->
                    <div class="mt-6 pt-6 border-t border-white border-opacity-20" *ngIf="!minimal">
                        <p class="text-center text-white text-opacity-80 text-xs">
                            By continuing, you agree to our 
                            <a href="#" class="underline hover:text-white transition-colors">Terms of Service</a> 
                            and 
                            <a href="#" class="underline hover:text-white transition-colors">Privacy Policy</a>
                        </p>
                    </div>
                </div>

                <!-- Help Section -->
                <div class="text-center mt-6" *ngIf="!minimal">
                    <p class="text-white text-opacity-70 text-sm">
                        Need help? 
                        <a href="#" class="text-white underline hover:text-opacity-100 transition-all">Contact Support</a>
                    </p>
                </div>
            </div>
        </div>
    </main>
</div>